import styled from 'styled-components';

import PromptCopyCard from '../../../../../PromptCopyCard';
import {
  LeftContent,
  PromptText,
  CopyButton
} from '../../../../../PromptCopyCard/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Caption = styled.div`
  font-size: 12.5px;
  color: ${({ theme }) => theme.text.emptyState};
  word-break: break-word;
`;

export const CommandCard = styled(PromptCopyCard)`
  ${LeftContent} {
    align-items: flex-start;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  ${PromptText} {
    width: 100%;
    min-width: 0;
  }

  ${CopyButton} {
    align-self: flex-start;
  }
`;

export const CodeText = styled.pre`
  margin: 0;
  overflow-x: auto;
  font-family: monospace;
  font-size: 12.5px;
  line-height: 1.65;
  color: ${({ theme }) => theme.text.workspaceItem};
  white-space: pre;
`;
